export enum JsonKey {
  // General
  CLOSE_BUTTON_ARIA_LABEL = 'CLOSE_BUTTON_ARIA_LABEL',

  // Navigation Component
  NAVIGATION_LINK_1 = 'NAVIGATION_LINK_1',
  NAVIGATION_LINK_2 = 'NAVIGATION_LINK_2',
  NAVIGATION_LINK_3 = 'NAVIGATION_LINK_3',
  NAVIGATION_LINK_4 = 'NAVIGATION_LINK_4',
  NAVIGATION_OPEN_ARIA_LABEL = 'NAVIGATION_OPEN_ARIA_LABEL',
  NAVIGATION_CLOSE_ARIA_LABEL = 'NAVIGATION_CLOSE_ARIA_LABEL',
  NAVIGATION_COMPARE = 'NAVIGATION_COMPARE',

  // Compare modal
  COMPARE_MODAL_ARIA_LABEL = 'COMPARE_MODAL_ARIA_LABEL',

  // Remote Control
  REMOTE_CONTROL_UP = 'REMOTE_CONTROL_UP',
  REMOTE_CONTROL_DOWN = 'REMOTE_CONTROL_DOWN',
  REMOTE_CONTROL_LEFT = 'REMOTE_CONTROL_LEFT',
  REMOTE_CONTROL_RIGHT = 'REMOTE_CONTROL_RIGHT',
  REMOTE_CONTROL_CENTER = 'REMOTE_CONTROL_CENTER',

  // Legal copy
  BROWSE_TITLES_LEGAL_DISCLAIMER_COPY = 'BROWSE_TITLES_LEGAL_DISCLAIMER_COPY',
  RECOMMENDATIONS_LEGAL_DISCLAIMER_COPY = 'RECOMMENDATIONS_LEGAL_DISCLAIMER_COPY',
  WATCHLIST_LEGAL_DISCLAIMER_COPY = 'WATCHLIST_LEGAL_DISCLAIMER_COPY',
  VOICE_LEGAL_DISCLAIMER_COPY = 'VOICE_LEGAL_DISCLAIMER_COPY',

  // More Info
  MORE_INFO_ARIA_LABEL = 'MORE_INFO_ARIA_LABEL',
  MORE_INFO_EYEBROW = 'MORE_INFO_EYEBROW',

  // Welcome Page
  WELCOME_PRIMARY_BUTTON_COPY = 'WELCOME_PRIMARY_BUTTON_COPY',
  WELCOME_PRIMARY_BUTTON_ARIA_LABEL = 'WELCOME_PRIMARY_BUTTON_ARIA_LABEL',
  WELCOME_SECONDARY_BUTTON_COPY = 'WELCOME_SECONDARY_BUTTON_COPY',
  WELCOME_SECONDARY_BUTTON_3P_COPY = 'WELCOME_SECONDARY_BUTTON_3P_COPY',
  WELCOME_ROTATE_DEVICE_COPY = 'WELCOME_ROTATE_DEVICE_COPY',
  // Browse Titles
  BROWSE_TITLES_MORE_INFO_TITLE = 'BROWSE_TITLES_MORE_INFO_TITLE',
  BROWSE_TITLES_MORE_INFO_MAIN_COPY = 'BROWSE_TITLES_MORE_INFO_MAIN_COPY',
  BROWSE_TITLES_MORE_INFO_GENERIC_COPY = 'BROWSE_TITLES_MORE_INFO_GENERIC_COPY',

  BROWSE_TITLES_MORE_INFO_LEGAL_FOOTER = 'BROWSE_TITLES_MORE_INFO_LEGAL_FOOTER',
  BROWSE_TITLES_MORE_INFO_LEGAL_GENERIC_FOOTER = 'BROWSE_TITLES_MORE_INFO_LEGAL_GENERIC_FOOTER',
  RECOMMENDATIONS_MORE_INFO_LEGAL_FOOTER = 'RECOMMENDATIONS_MORE_INFO_LEGAL_FOOTER',
  WATCHLIST_MORE_INFO_LEGAL_FOOTER = 'WATCHLIST_MORE_INFO_LEGAL_FOOTER',
  VOICE_MORE_INFO_LEGAL_FOOTER = 'VOICE_MORE_INFO_LEGAL_FOOTER',

  BROWSE_TITLES_IMAGE_ALTTEXT = 'BROWSE_TITLES_IMAGE_ALTTEXT',
  BROWSE_TITLES_COACHMARK_1 = 'BROWSE_TITLES_COACHMARK_1',
  BROWSE_TITLES_COACHMARK_2 = 'BROWSE_TITLES_COACHMARK_2',

  // Entertainment Recommendations
  RECOMMENDATIONS_MORE_INFO_TITLE = 'RECOMMENDATIONS_MORE_INFO_TITLE',
  RECOMMENDATIONS_MORE_INFO_MAIN_COPY = 'RECOMMENDATIONS_MORE_INFO_MAIN_COPY',
  RECOMMENDATIONS_COACHMARK_1 = 'RECOMMENDATIONS_COACHMARK_1',
  RECOMMENDATIONS_COACHMARK_2 = 'RECOMMENDATIONS_COACHMARK_2',

  // Watchlist
  WATCHLIST_MORE_INFO_TITLE = 'WATCHLIST_MORE_INFO_TITLE',
  WATCHLIST_MORE_INFO_MAIN_COPY = 'WATCHLIST_MORE_INFO_MAIN_COPY',
  WATCHLIST_COACHMARK_1 = 'WATCHLIST_COACHMARK_1',
  WATCHLIST_ADD_SHOWS_FROM_DEVICE = 'WATCHLIST_ADD_SHOWS_FROM_DEVICE',

  // Voice Search
  SPEECH_BUTTON_ARIA_LABEL = 'SPEECH_BUTTON_ARIA_LABEL',
  VOICE_COPY = 'VOICE_COPY',
  VOICE_COACHMARK = 'VOICE_COACHMARK',
  VOICE_IMAGE_ALTTEXT = 'VOICE_IMAGE_ALTTEXT',
  VOICE_MORE_INFO_TITLE = 'VOICE_MORE_INFO_TITLE',
  VOICE_MORE_INFO_MAIN_COPY = 'VOICE_MORE_INFO_MAIN_COPY',
  VOICE_INTRO_TRY_SAYING_COPY = 'VOICE_INTRO_TRY_SAYING_COPY',
  VOICE_INTRO_PLEASE_WAIT = 'VOICE_INTRO_PLEASE_WAIT',
  VOICE_INTRO_CHOOSE_ONE_COPY = 'VOICE_INTRO_CHOOSE_ONE_COPY',
  VOICE_INTRO_FEATURE_1 = 'VOICE_INTRO_FEATURE_1',
  VOICE_INTRO_FEATURE_2 = 'VOICE_INTRO_FEATURE_2',
  VOICE_INTRO_FEATURE_3 = 'VOICE_INTRO_FEATURE_3',
  VOICE_INTRO_FEATURE_4 = 'VOICE_INTRO_FEATURE_4',
  VOICE_VIDEO_TITLE = 'VOICE_VIDEO_TITLE',

  // Compare modal
  SPECS_4K_TITLE = 'SPECS_4K_TITLE',
  SPECS_4K_COLOR_TITLE = 'SPECS_4K_COLOR_TITLE',
  SPECS_4K_COLOR_COPY = 'SPECS_4K_COLOR_COPY',
  SPECS_4K_VIDEO_RESOLUTION_TITLE = 'SPECS_4K_VIDEO_RESOLUTION_TITLE',
  SPECS_4K_VIDEO_RESOLUTION_BODY = 'SPECS_4K_VIDEO_RESOLUTION_BODY',
  SPECS_4K_VOICE_REMOTE_TITLE = 'SPECS_4K_VOICE_REMOTE_TITLE',
  SPECS_4K_VIDEO_RESOLUTION_COPY = 'SPECS_4K_VIDEO_RESOLUTION_COPY',
  SPECS_4K_WITH_GOOGLE_TV_TITLE = 'SPECS_4K_WITH_GOOGLE_TV_TITLE',
  SPECS_4K_WITH_GOOGLE_TV_BODY_LINE_1 = 'SPECS_4K_WITH_GOOGLE_TV_BODY_LINE_1',
  SPECS_4K_WORKS_WITH_APPS_TITLE = 'SPECS_4K_WORKS_WITH_APPS_TITLE',
  SPECS_4K_WITH_GOOGLE_TV_COPY = 'SPECS_4K_WITH_GOOGLE_TV_COPY',
  SPECS_4K_NEST_SPEAKERS_TITLE = 'SPECS_4K_NEST_SPEAKERS_TITLE',
  SPECS_4K_WORKS_WITH_APPS_COPY = 'SPECS_4K_WORKS_WITH_APPS_COPY',
  SPECS_4K_CONTROL_DEVICES_TITLE = 'SPECS_4K_CONTROL_DEVICES_TITLE',
  SPECS_4K_NEST_SPEAKERS_COPY = 'SPECS_4K_NEST_SPEAKERS_COPY',
  SPECS_4K_CAST_TITLE = 'SPECS_4K_CAST_TITLE',
  SPECS_4K_CONTROL_DEVICES_COPY = 'SPECS_4K_CONTROL_DEVICES_COPY',
  SPECS_4K_STADIA_COMPATIBLE_TITLE = 'SPECS_4K_STADIA_COMPATIBLE_TITLE',
  SPECS_4K_CAST_COPY = 'SPECS_4K_CAST_COPY',
  SPECS_4K_DIMENSIONS_WEIGHT_TITLE = 'SPECS_4K_DIMENSIONS_WEIGHT_TITLE',
  SPECS_4K_DIMENSIONS_WEIGHT_BODY_LINE_1 = 'SPECS_4K_DIMENSIONS_WEIGHT_BODY_LINE_1',
  SPECS_4K_CONNECTIVITY_TITLE = 'SPECS_4K_CONNECTIVITY_TITLE',
  SPECS_4K_CONNECTIVITY_BODY_LINE_1 = 'SPECS_4K_CONNECTIVITY_BODY_LINE_1',
  SPECS_4K_VIDEO_FORMATS_TITLE = 'SPECS_4K_VIDEO_FORMATS_TITLE',
  SPECS_4K_VIDEO_FORMATS_BODY = 'SPECS_4K_VIDEO_FORMATS_BODY',
  SPECS_4K_PORTS_TITLE = 'SPECS_4K_PORTS_TITLE',
  SPECS_4K_PORTS_BODY_LINE_1 = 'SPECS_4K_PORTS_BODY_LINE_1',

  SEPCS_HD_TITLE = 'SEPCS_HD_TITLE',
  SPECS_HD_COLORS_TITLE = 'SPECS_HD_COLORS_TITLE',
  SPECS_HD_COLORS_COPY = 'SPECS_HD_COLORS_COPY',
  SPECS_HD_VIDEO_RESOLUTION_TITLE = 'SPECS_HD_VIDEO_RESOLUTION_TITLE',
  SPECS_HD_VIDEO_RESOLUTION_BODY = 'SPECS_HD_VIDEO_RESOLUTION_BODY',
  SPECS_HD_VOICE_REMOTE_TITLE = 'SPECS_HD_VOICE_REMOTE_TITLE',
  SPECS_HD_VIDEO_RESOLUTION_COPY = 'SPECS_HD_VIDEO_RESOLUTION_COPY',
  SPECS_HD_WITH_GOOGLE_TV_TITLE = 'SPECS_HD_WITH_GOOGLE_TV_TITLE',
  SPECS_HD_WITH_GOOGLE_TV_BODY_LINE_1 = 'SPECS_HD_WITH_GOOGLE_TV_BODY_LINE_1',
  SPECS_HD_WORKS_WITH_APPS_TITLE = 'SPECS_HD_WORKS_WITH_APPS_TITLE',
  SPECS_HD_WITH_GOOGLE_TV_COPY = 'SPECS_HD_WITH_GOOGLE_TV_COPY',
  SPECS_HD_NEST_SPEAKERS_TITLE = 'SPECS_HD_NEST_SPEAKERS_TITLE',
  SPECS_HD_WORKS_WITH_APPS_COPY = 'SPECS_HD_WORKS_WITH_APPS_COPY',
  SPECS_HD_CONTROL_DEVICES_TITLE = 'SPECS_HD_CONTROL_DEVICES_TITLE',
  SPECS_HD_NEST_SPEAKERS_COPY = 'SPECS_HD_NEST_SPEAKERS_COPY',
  SPECS_HD_CAST_TITLE = 'SPECS_HD_CAST_TITLE',
  SPECS_HD_CONTROL_DEVICES_COPY = 'SPECS_HD_CONTROL_DEVICES_COPY',
  SPECS_HD_STADIA_COMPATIBLE_TITLE = 'SPECS_HD_STADIA_COMPATIBLE_TITLE',
  SPECS_HD_CAST_COPY = 'SPECS_HD_CAST_COPY',
  SPECS_HD_DIMENSIONS_WEIGHT_TITLE = 'SPECS_HD_DIMENSIONS_WEIGHT_TITLE',
  SPECS_HD_DIMENSIONS_WEIGHT_BODY_LINE_1 = 'SPECS_HD_DIMENSIONS_WEIGHT_BODY_LINE_1',
  SPECS_HD_CONNECTIVITY_TITLE = 'SPECS_HD_CONNECTIVITY_TITLE',
  SPECS_HD_CONNECTIVITY_BODY_LINE_1 = 'SPECS_HD_CONNECTIVITY_BODY_LINE_1',
  SPECS_HD_VIDEO_FORMATS_TITLE = 'SPECS_HD_VIDEO_FORMATS_TITLE',
  SPECS_HD_VIDEO_FORMATS_BODY = 'SPECS_HD_VIDEO_FORMATS_BODY',
  SPECS_HD_PORTS_TITLE = 'SPECS_HD_PORTS_TITLE',
  SPECS_HD_PORTS_BODY_LINE_1 = 'SPECS_HD_PORTS_BODY_LINE_1',

  SPECS_FOOTER_COPY_1 = 'SPECS_FOOTER_COPY_1',
  SPECS_FOOTER_COPY_2 = 'SPECS_FOOTER_COPY_2',

  // Opening screen
  OPENING_SCREEN_BROWSE_TITLES_COPY = 'OPENING_SCREEN_BROWSE_TITLES_COPY',
  OPENING_SCREEN_RECOMMENDATIONS_COPY = 'OPENING_SCREEN_RECOMMENDATIONS_COPY',
  OPENING_SCREEN_WATCHLIST_COPY = 'OPENING_SCREEN_WATCHLIST_COPY',
  OPENING_SCREEN_VOICE_COPY = 'OPENING_SCREEN_VOICE_COPY',

  // End screen
  END_SCREEN_LINK_1 = 'END_SCREEN_LINK_1',
  END_SCREEN_LINK_2 = 'END_SCREEN_LINK_2',
  END_SCREEN_LINK_3 = 'END_SCREEN_LINK_3',
  END_SCREEN_LINK_4 = 'END_SCREEN_LINK_4',
  END_SCREEN_RECOMMENDATIONS_TITLE = 'END_SCREEN_RECOMMENDATIONS_TITLE',
  END_SCREEN_RECOMMENDATIONS_COPY = 'END_SCREEN_RECOMMENDATIONS_COPY',
  END_SCREEN_WATCHLIST_TITLE = 'END_SCREEN_WATCHLIST_TITLE',
  END_SCREEN_WATCHLIST_COPY = 'END_SCREEN_WATCHLIST_COPY',
  END_SCREEN_BROWSE_TITLES_TITLE = 'END_SCREEN_BROWSE_TITLES_TITLE',
  END_SCREEN_BROWSE_TITLES_COPY = 'END_SCREEN_BROWSE_TITLES_COPY',
  END_SCREEN_VOICE_TITLE = 'END_SCREEN_VOICE_TITLE',
  END_SCREEN_VOICE_COPY = 'END_SCREEN_VOICE_COPY',

  // Voice search end screen
  END_SCREEN_VOICE_LIGHTS_TITLE = 'END_SCREEN_VOICE_LIGHTS_TITLE',
  END_SCREEN_VOICE_LIGHTS_COPY = 'END_SCREEN_VOICE_LIGHTS_COPY',
  END_SCREEN_VOICE_ACTION_TITLE = 'END_SCREEN_VOICE_ACTION_TITLE',
  END_SCREEN_VOICE_ACTION_COPY = 'END_SCREEN_VOICE_ACTION_COPY',
  END_SCREEN_VOICE_CHILDREN_TITLE = 'END_SCREEN_VOICE_CHILDREN_TITLE',
  END_SCREEN_VOICE_CHILDREN_COPY = 'END_SCREEN_VOICE_CHILDREN_COPY',
  END_SCREEN_VOICE_DOOR_TITLE = 'END_SCREEN_VOICE_DOOR_TITLE',
  END_SCREEN_VOICE_DOOR_COPY = 'END_SCREEN_VOICE_DOOR_COPY',
  END_SCREEN_VOICE_TRY_AGAIN = 'END_SCREEN_VOICE_TRY_AGAIN',
  END_SCREEN_VOICE_SPECS = 'END_SCREEN_VOICE_SPECS',

  // Audio response
  AUDIO_RESPONSE_LIGHTS = 'AUDIO_RESPONSE_LIGHTS',
  AUDIO_RESPONSE_FRONT_DOOR = 'AUDIO_RESPONSE_FRONT_DOOR',
  AUDIO_RESPONSE_ERROR = 'AUDIO_RESPONSE_ERROR',
}

export type JsonKeyCode = keyof typeof JsonKey;
